import { render, staticRenderFns } from "./MedisGs1s.vue?vue&type=template&id=17df1307&"
import script from "./MedisGs1s.vue?vue&type=script&lang=ts&"
export * from "./MedisGs1s.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports